const blockGridYouTube = () => {
  const init = () => {
    const $blocks = $('.block-grid-youtube__section');
    if (!$blocks.length) return;

    $blocks.each(function () {
      const url = this.getAttribute('data-url');
      const contactUrl = this.getAttribute('data-contact-url');
      const contactLabel = this.getAttribute('data-contact-label');
      const loadLabel = this.getAttribute('data-load-label');

      $(this).youmaxPro({
        tabs: [{ type: 'youtube-channel-uploads', link: url, name: 'Uploads' }],
        defaultTab: 'Uploads',
        youmaxDisplayMode: 'grid',
        gridThumbnailType: 'full',
        channelLinkForHeader: url,
        maxResults: 6,
        loadingMechanism: 'load-more',
        loadMoreText: "<i class='fa fa-plus'></i>" + loadLabel,
        videoDisplayMode: 'popup',
        autoPlay: true,
        dateFormat: 'relative',
        // youmaxBackgroundColor: '#ECEFF1',
        itemBackgroundColor: '#ffffff',
        titleColor: '#005D9F',
        descriptionColor: '#54565A',
        // viewsColor: '#6f6f6f',
        controlsTextColor: 'black',
        baseFontSize: '16px',
        titleFontFamily: '"Ubuntu", sans-serif',
        // titleFontSize: '0.9',
        // titleFontWeight: 'normal',
        generalFontFamily: '"Ubuntu", sans-serif',
        // descriptionFontSize: '0.85',
        // viewsDateFontSize: '0.75',
        apiKey: 'AIzaSyB5j5hyr7y9u4sA4R4cA_23oJW3HaSX-HY',
        displayFirstVideoOnLoad: true,
        previousButtonText: 'Precedente',
        nextButtonText: 'Prossimo',
        ctaText: "<i class='fa fa-envelope'></i>" + contactLabel,
        ctaLink: contactUrl,
        minimumViewsPerDayForTrendingVideos: '5'
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
};

export default blockGridYouTube;
